import { combineReducers, configureStore, getDefaultMiddleware, Store } from '@reduxjs/toolkit';
import accountsReducer from 'src/features/accounts/accounts.state';
import authReducer from 'src/features/auth/auth.state';
import collectionsReducer from 'src/features/collections/collections.state';
import templatesReducer from 'src/features/templates/templates.state';
import companiesReducer from 'src/features/companies/companies.state';
import companyOffersReducer from 'src/features/companyOffers/companyOffers.state';
import companyCmdReducer from 'src/features/companyCmd/companyCmd.state';
import companyBannersReducer from 'src/features/companyBanners/companyBanners.state';
import companyVideosReducer from 'src/features/companyVideos/companyVideos.state';
import companyPackagesReducer from 'src/features/companyPackages/companyPackages.state';
import companyParametersReducer from 'src/features/companyParameters/companyParameters.state';
import companyAccountsReducer from 'src/features/companyAccounts/companyAccounts.state';
import companyBillingReducer from 'src/features/companyBilling/companyBilling.state';
import contentsReducer from 'src/features/contents/contents.state';
import devicesTypesReducer from 'src/features/devicesTypes/devicesTypes.state';
import firmwareGroupsReducer from 'src/features/firmwareGroups/firmwareGroups.state';
import firmwaresReducer from 'src/features/firmwares/firmwares.state';
import languagesReducer from 'src/features/languages/languages.state';
import locationsReducer from 'src/features/locations/locations.state';
import paymentProvidersReducer from 'src/features/paymentProvider/paymentProvider.state';
import subscriptionsReducer from 'src/features/subscriptions/subscriptions.state';
import devicesReducer from 'src/features/devices/devices.state';
import deviceGroupsReducer from 'src/features/deviceGroups/deviceGroups.state';
import deviceGroupVideosReducer from 'src/features/deviceGroupVideos/deviceGroupVideos.state';
import usersReducer from 'src/features/users/users.state';
import phyDevicesReducer from 'src/features/phy_devices/state';
import createSagaMiddleware, { Task } from 'redux-saga';
import rootSaga from '../saga';
import serviceProviderReducer from 'src/features/serviceProvider/state';
import offlineTemplateReducer from 'src/features/templates/offlineTemplate.state';

const reducer = combineReducers({
  auth: authReducer,
  accounts: accountsReducer,
  paymentProviders: paymentProvidersReducer,
  serviceProvider: serviceProviderReducer,
  companies: companiesReducer,
  companyOffers: companyOffersReducer,
  companyCmd: companyCmdReducer,
  companyBanners: companyBannersReducer,
  companyPackages: companyPackagesReducer,
  companyAccounts: companyAccountsReducer,
  companyBilling: companyBillingReducer,
  subscriptions: subscriptionsReducer,
  devices: devicesReducer,
  users: usersReducer,
  locations: locationsReducer,
  languages: languagesReducer,
  devicesTypes: devicesTypesReducer,
  firmwares: firmwaresReducer,
  firmwareGroups: firmwareGroupsReducer,
  collections: collectionsReducer,
  contents: contentsReducer,
  templates: templatesReducer,
  companyParameters: companyParametersReducer,
  companyVideos: companyVideosReducer,
  deviceGroups: deviceGroupsReducer,
  deviceGroupVideos: deviceGroupVideosReducer,
  phyDevices: phyDevicesReducer,
  offlineTemplate: offlineTemplateReducer,
});

export interface SagaStore extends Store {
  sagaTask: Task;
}

const createStore = () => {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    reducer,
    middleware: getDefaultMiddleware().concat(sagaMiddleware),
    enhancers: [],
    devTools: true,
  });

  (store as SagaStore).sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};

export type RootState = ReturnType<typeof reducer>;

export default createStore;
